<template>
  <div class="event-list">
    <div class="event" v-if="events.length > 0">
      <div class="title">比赛事件</div>
      <div class="event-content">
        <div class="event-item" v-for="item in events" :key="item.id" :class="item.teamId === homeTeam.id ? 'home' : 'away'">
          <div class="time">
            <div class="time-text">
              <span v-if="item.begin">{{ item.begin }}</span>
              <span v-else>{{ item.time }}</span>
            </div>
            <div class="score">
              <span v-if="item.catalog === 'penalty'">判罚</span>
              <span v-else>{{ item.homeScore }}:{{ item.awayScore }}</span>
            </div>
          </div>
          <div class="img">
            <img :src="item.teamId === homeTeam.id ? homeIcon : awayIcon" />
            <div v-if="item.duizhen && item.catalog !== 'penalty'">{{ item.duizhen }}</div>
            <div v-if="item.type && item.catalog === 'penalty'" class="penalty-type">{{ item.type }}</div>
          </div>
          <div class="info">
            <div class="name overflow-text">[{{ item.player.jerseyNo }}]{{ item.player.name }}</div>
            <div class="text" v-if="item.catalog === 'penalty'">
              结束：{{ item.end }}
            </div>
            <div class="text overflow-text" v-else>
              一助：<span v-if="item.other1">[{{ item.other1.jerseyNo }}]{{ item.other1.name }}</span>
              二助：<span v-if="item.other2">[{{ item.other2.jerseyNo }}]{{ item.other2.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shoot" v-if="homeShooters.length > 0 || awayShooters.length > 0">
      <div class="title">射门大赛</div>
      <div class="shoot-content">
        <div class="left">
          <div class="item" v-for="item in homeShooters" :key="item.id">
            <div class="info">
              <div class="name">{{ item.player.name }}</div>
              <div class="text">
                <span>{{ item.player.jerseyNo }}号</span>
                <span>{{ item.player.position }}</span>
              </div>
            </div>
            <div class="type">
              <u-icon name="checkmark-circle-fill" color="#3FD57B" v-if="item.goal === 1"></u-icon>
              <u-icon name="close-circle-fill" color="#D54F3F" v-else></u-icon>
            </div>
          </div>
        </div>
        <div class="right">
         <div class="item" v-for="item in awayShooters" :key="item.id">
            <div class="type" style="margin-right: 16rpx;">
              <u-icon name="checkmark-circle-fill" color="#3FD57B" v-if="item.goal === 1"></u-icon>
              <u-icon name="close-circle-fill" color="#D54F3F" v-else></u-icon>
            </div>
            <div class="info">
              <div class="name">{{ item.player.name }}</div>
              <div class="text">
                <span>{{ item.player.jerseyNo }}号</span>
                <span>{{ item.player.position }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="events.length === 0 && homeShooters.length === 0 && awayShooters.length === 0" class="kong">
      <img src="https://images.snsports.cn/bsn_kong.png" />
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
import { getGameScore } from '@/api/match'
export default {
  props: {
    beibingGameId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      homeTeam: {},
      awayTeam: {},
      homeIcon: '',
      awayIcon: '',
      events: [],
      homeShooters: [],
      awayShooters: []
    };
  },
  mounted() {
    this.getGameScore()
  },
  methods: {
    getGameScore() {
      if(!this.beibingGameId) return
      getGameScore({id: this.beibingGameId}).then(res => {
        const { data } = res
        this.homeTeam = data.game.homeTeam
        this.awayTeam = data.game.awayTeam
        this.homeIcon = 'https://image.bjh.snsports.cn/' + data.game.homeTeam.badge + '?imageView2/1/w/120/h/120'
        this.awayIcon = 'https://image.bjh.snsports.cn/' +data.game.awayTeam.badge + '?imageView2/1/w/120/h/120'
        this.events = data.events
        this.homeShooters = data.game.homeTeam.shootouts
        this.awayShooters = data.game.awayTeam.shootouts
      })
    }
  },
};
</script>

<style scoped lang="scss">
.event-list{
  padding: 12px 16px;
  background-color: #fff;
  .title{
    margin-bottom: 13px;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
  }
  .event{
    margin-bottom: 35px;
  }
  .event-content{
    .event-item{
      display: flex;
      height: 62px;
      border-radius: 5px;
      padding: 7px 20px 0 13px;
      box-sizing: border-box;
      margin-bottom: 8px;
      .time{
        width: 42px;
        min-width: 42px;
        .time-text{
          font-size: 14px;
          color: #303133;
          padding-top: 3px;
        }
        .score{
          font-size: 16px;
          font-weight: bold;
          color: #303133;
          margin-top: 7px;
        }
      }
      .img{
        margin-right: 12px;
        // margin-left: 21px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        width: 75px;
        min-width: 75px;
        img{
          width: 28px;
          height: 28px;
          border-radius: 50%;
        }
        // .penalty-type{
        //   width: 60px;
        //   text-align: center;
        // }
      }
      .info{
        padding-top: 5px;
        .name{
          color: #303133;
          font-size: 14px;
        }
        .text{
          color: #606266;
          font-size: 12px;
          margin-top: 7px;
          span{
            margin-right: 10px;
          }
        }
      }
    }
    .home{
      background: rgba(38, 161, 255, 0.1);
      .img{
        color: #26A1FF;
      }
    }
    .away{
      background: rgba(250, 104, 43, 0.1);
      .img{
        color: #FA682B;
      }
    }
  }
  .shoot{
    .shoot-content{
      display: flex;
      justify-content: space-between;
      .item{
        width: 165px;
        height: 50px;
        border-radius: 5px;
        display: flex;
        justify-content: space-between;
        padding: 8px 8px 5px 11px;
        box-sizing: border-box;
        margin-bottom: 6px;
        .info{
          flex: 1;
          .name{
            color: #303133;
            font-size: 12px;
          }
          .text{
            color: #73767A;
            font-size: 12px;
            margin-top: 3px;
            span{
              margin-right: 6px;
            }
          }
        }
        .type{
          width: 18px;
          text-align: center;
          font-size: 18px;
        }
      }
      .left{
        .item{
          background: linear-gradient(270deg, #E9F6FF 0%, rgba(233, 246, 255, 0) 100%);
        }
      }
      .right{
        .item{
          background: linear-gradient(90deg, #FEF0EA 0%, rgba(254, 245, 245, 0) 100%);
        }
      }
    }
  }
  .kong{
    text-align: center;
    img{
      width: 120px;
      height: 120px;
    }
    p{
      color: #B9BAB9;
      font-size: 14px;
      margin-top: 8px;
    }
  }
}
</style>
